import React, { useState, useMemo } from 'react';
import { useSelectDegree } from '../../catalogos/generico/hooks/genericoHook';
import { useEducationDegree } from '../hooks/DashboardHook';

type Props = {
  filterDate: any;
  loadingGrid: boolean;
};

const GraficaNivel: React.FC<Props> = ({ filterDate, loadingGrid }) => {
  const [statusFilter, setStatusFilter] = useState<number>(2);
  const [order, setOrder] = useState<'asc' | 'desc'>('desc');
  
  // Usar useMemo para estabilizar el objeto de filtros y evitar re-renders innecesarios
  const initValues = useMemo(() => ({
    order: order,
    degreeId: statusFilter,
    init_date: filterDate.init_date,
    end_date: filterDate.end_date,
  }), [order, statusFilter, filterDate.init_date, filterDate.end_date]);
  
  const { data: degree } = useSelectDegree(true);
  const { data: Student } = useEducationDegree(true, initValues);

  return (
    <div className="card card-flush w-100 h-475px me-2">
      <div className="card-header pt-5">
        <h3 className="card-title align-items-start flex-column">
          <span className="card-label fw-bold text-dark fs-3">
            Usuarios por nivel académico
          </span>
          <span className="text-gray-400 mt-1 fw-semibold fs-6">
            Estudiantes registrados
          </span>
        </h3>
      </div>
      <div className="card-body pt-0">
        {loadingGrid ? (
          <div className="d-flex align-items-center">
            <div className="text-muted text-center fs-6 w-100 m-5">
              <span className="indicator-progress" style={{ display: 'block' }}>
                Espere por favor...
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            </div>
          </div>
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-center w-100 mb-3 mt-3">
              <div>
                {degree.map((row) => (
                  <button
                    key={row.id}
                    className={`btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bold px-4 me-1 ${
                      statusFilter === row.id ? 'active' : ''
                    }`}
                    onClick={() => setStatusFilter(row.id)}
                  >
                    {row.name}
                  </button>
                ))}
              </div>
              <div>
                <button
                  className="nav-link btn btn-sm btn-bg-secondary text-gray-500 px-4 me-1"
                  onClick={() =>
                    setOrder((prev) => (prev === 'asc' ? 'desc' : 'asc'))
                  }
                >
                  Ordenar {order === 'asc' ? '▲' : '▼'}
                </button>
              </div>
            </div>

            <div
              style={{
                maxHeight: '320px',
                overflowY: 'auto',

                marginTop: '1rem',
              }}
            >
              {Student.length === 0 ? (
                <div className="text-muted text-center py-4">Sin registros</div>
              ) : (
                <>
                  <div className="d-flex fw-bold border-bottom px-3 py-2">
                    <div style={{ width: '10%' }}>#</div>
                    <div style={{ width: '50%' }}>Institución</div>
                    <div style={{ width: '40%', textAlign: 'right' }}>
                      Usuarios
                    </div>
                  </div>

                  {Student.map((row, idx) => {
                    const rowNumber =
                      order === 'asc' ? Student.length - idx : idx + 1;

                    return (
                      <div
                        key={row.id}
                        className="d-flex align-items-center px-3 py-2"
                      >
                        <div style={{ width: '10%' }}>{rowNumber}</div>
                        <div
                          style={{
                            width: '50%',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {row.name}
                        </div>
                        <div style={{ width: '40%', textAlign: 'right' }}>
                          {row.total_students}
                        </div>
                      </div>
                    );
                  })}
                </>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export { GraficaNivel };
